// a name based route map for the web app
export const apiRoutes = Object.freeze({
  config: "/web/config/",
  now_showing: "/cinema/nowshowing/",
  banner: "/cinema/cinebanner/",
  "advertisement-banner": "/cinema/promo-banner/",
  "advertisement-detail": "/cinema/promo-banner/:idx/",
  next_release: "/cinema/nextrelease/",
  coming_soon: "/cinema/comingsoon/",
  movie_detail: "/cinema/moviedetail/:idx/",
  show_detail_list: "/cinema/showdetail/",
  cinema_hall_list: "/cinema/cinemahall/",
  cinema_hall_location_list: "/cinema/hall/location-detail/",
  cine_setting: "/cinema/setting/:idx/",
  seat_selection: "cinema/show/select/select-seat/",
  clear_seat_selection: "cinema/show/clear-seats/",

  login_user: "/auth/login/",
  logout_user: "/auth/logout/",
  register_user: "/auth/register/",
  user_profile: "/users/me/",
  user_profile_update: "/profile/update/",
  forgot_password: "/users/forgot-password/",
  reset_password: "/auth/reset-password/",
  change_password: "/auth/change-password/",
  social_login_initiate: "/social/:idx/init/",
  social_login_verify: "/social/:idx/verify/",

  payment_methods: "/cinema/show/payment/",
  show_detail: "/cinema/show/seats/",

  booking: "/cinema/booking/",
  booking_detail: "/cinema/booking/detail/",
  proceed_booking: "/cinema/booking/proceed/",
  reserve_seat: "/cinema/booking/reserve-seat/",
  payment_initiate: "/cinema/booking/payment-initiate/",
  voucher_validate: "/cinema/booking/voucher/validate/",
  payment_status: "/cinema/booking/payment-verify/",
  "user-history": "/cinema/history/",
  "user-reservations": "/cinema/booking/reserved/",

  "generate-ticket": "/cinema/ticket-print/generate-pdf/",

  "global-movie-list": "/cinema/movies/",

  "get-mobile-verification-otp": "/member/verify/otp/",
  "verify-mobile-verification-otp": "/member/verify/verify-otp/",
  "user-loyalty-points": "/cinema/loyalty/transaction/",
  "loyalty-earning-status": "/cinema/loyalty/earning-status/",

  category: "/menu/category/",
  "menu-items": "/menu/item/",
  "combo-packages": "/menu/combopackage/",
  foodBookingProceed: "/cinema/booking/add-food/",
  getBookingDetail: "/cinema/booking/order-detail/",
  food_checkout: "/cinema/food/payment/checkout/",
  food_payment_verify: "/cinema/food/payment/verify/",
  generate_food_ticket: "/cinema/food/payment/:idx/print-ticket/",
  food_payment_methods: "/cinema/food/payment/methods/",
  get_global_ticket: "/cinema/global-ticket/",

  contact_us: "/contact-us/",

  // WhatsApp messaging (claude/design/whatsapp-messaging/02 §11.3).
  whatsapp_me: "/whatsapp/me/",
});

export default apiRoutes;
